import { useEffect, useRef } from 'react';

/** Returns a ref that stays true until the component unmounts. */
export function useIsMounted() {
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    return isMountedRef;
}
